<ziro-select fieldId="keyword-search" (selectWasClosed)="handleSelectClosed()"></ziro-select>
